import * as l from "react";
import { p as i } from "./index-efd35e77.js";
import { A as f } from "./Animation-d8a017b3.js";
import "./TransitionGroup-34043d49.js";
import "react-dom";
import "./index-64063129.js";
var y = globalThis && globalThis.__extends || function() {
  var e = function(r, t) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
      n.__proto__ = o;
    } || function(n, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (n[a] = o[a]);
    }, e(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    e(r, t);
    function n() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), s = globalThis && globalThis.__assign || function() {
  return s = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, s.apply(this, arguments);
}, h = globalThis && globalThis.__rest || function(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}, d = (
  /** @class */
  function(e) {
    y(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.render = function() {
      var t = this.props, n = t.direction, o = t.children, a = h(t, ["direction", "children"]), c = {
        transitionName: "expand-".concat(n)
      };
      return l.createElement(f, s({}, c, a), o);
    }, r.propTypes = {
      children: i.oneOfType([
        i.arrayOf(i.node),
        i.node
      ]),
      childFactory: i.any,
      className: i.string,
      direction: i.oneOf([
        "horizontal",
        "vertical"
      ]),
      component: i.string,
      id: i.string,
      style: i.any
    }, r.defaultProps = {
      appear: !1,
      enter: !0,
      exit: !0,
      transitionEnterDuration: 300,
      transitionExitDuration: 300,
      direction: "vertical"
    }, r;
  }(l.Component)
), g = globalThis && globalThis.__extends || function() {
  var e = function(r, t) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
      n.__proto__ = o;
    } || function(n, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (n[a] = o[a]);
    }, e(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    e(r, t);
    function n() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), p = globalThis && globalThis.__assign || function() {
  return p = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, p.apply(this, arguments);
}, _ = globalThis && globalThis.__rest || function(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}, O = { position: "absolute", top: "0", left: "0" }, m = (
  /** @class */
  function(e) {
    g(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.render = function() {
      var t = this.props, n = t.children, o = t.direction, a = _(t, ["children", "direction"]);
      return l.createElement(f, p({}, a, { transitionName: "push-".concat(o), animationExitingStyle: this.props.stackChildren ? O : void 0 }), n);
    }, r.propTypes = {
      children: i.oneOfType([
        i.arrayOf(i.node),
        i.node
      ]),
      childFactory: i.any,
      className: i.string,
      direction: i.oneOf([
        "up",
        "down",
        "left",
        "right"
      ]),
      component: i.string,
      id: i.string,
      style: i.any,
      stackChildren: i.bool
    }, r.defaultProps = {
      appear: !1,
      enter: !0,
      exit: !0,
      transitionEnterDuration: 300,
      transitionExitDuration: 300,
      direction: "right",
      stackChildren: !1
    }, r;
  }(l.Component)
), v = globalThis && globalThis.__extends || function() {
  var e = function(r, t) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
      n.__proto__ = o;
    } || function(n, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (n[a] = o[a]);
    }, e(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    e(r, t);
    function n() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), u = globalThis && globalThis.__assign || function() {
  return u = Object.assign || function(e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, u.apply(this, arguments);
}, b = globalThis && globalThis.__rest || function(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}, x = (
  /** @class */
  function(e) {
    v(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.render = function() {
      var t = this.props, n = t.direction, o = t.children, a = b(t, ["direction", "children"]), c = {
        transitionName: "slide-".concat(n)
      };
      return l.createElement(f, u({}, c, a), o);
    }, r.propTypes = {
      children: i.oneOfType([
        i.arrayOf(i.node),
        i.node
      ]),
      childFactory: i.any,
      className: i.string,
      direction: i.oneOf([
        "up",
        "down",
        "left",
        "right"
      ]),
      component: i.string,
      id: i.string,
      style: i.any
    }, r.defaultProps = {
      appear: !1,
      enter: !0,
      exit: !0,
      transitionEnterDuration: 300,
      transitionExitDuration: 300,
      direction: "down"
    }, r;
  }(l.Component)
);
const S = {
  Slide: x,
  Push: m,
  Expand: d
};
export {
  S as Animations
};
